
const CheckSquareIcon = ({
  size = 18,
  fill = "#3C2212",
  stroke = "#222222",
  checkStroke = "white",
  strokeWidth = 1.5,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="16"
      height="16"
      rx="4"
      transform="matrix(-1 0 0 1 17 1)"
      stroke={stroke}
    />
    <path
      d="M4.50007 8.99911L7.50056 11.8121L13.5 6.18748"
      stroke={checkStroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckSquareIcon;
